/* src/app/requests/request-detail-empty/request-detail-empty.component.scss */
:host {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
/*# sourceMappingURL=request-detail-empty.component.css.map */
